import { INITIAL_ANALYSIS_SELECTIONS } from "../../modules/samples/components/reanalyze/reanalyze-popup/consts";
import { LayoutType } from "../@types";

export const LAYOUT_TYPE: { XL: LayoutType; LG: LayoutType; MD: LayoutType } = {
  XL: "xl",
  LG: "lg",
  MD: undefined
};

export const INITIAL_FILE_UPLOAD_ANALYSIS_SELECTIONS = {
  ...INITIAL_ANALYSIS_SELECTIONS,
  tc: true
};

export const DYNAMIC_ANALYSIS_OPTIONS = [
  "rl_auxiliary_analysis",
  "rl_dynamic_analysis",
  "rl_dynamic_analysis_interactive",
  "cape",
  "cisco_secure_malware_analytics",
  "cuckoo",
  "fireeye",
  "joe",
  "vmray_tcbase"
];
